import { Box } from '@mui/material';
import { ProfileViewContainer } from 'modules/ProfileView';
import { useParams } from 'react-router-dom';

type Props = {}

const ProfileView = (props: Props) => {
    const { userType } = useParams();
    return (

        <ProfileViewContainer />

    )
}

export default ProfileView  